import { Navigate, useRoutes } from "react-router-dom";
import VideoChoose from "src/pages/VideoChoose";
import VideoChooseV2 from "src/pages/VideoChooseV2";
import VideoChooseV3 from "src/pages/VideoChooseV3";

export default function Router() {
  return useRoutes([
    {
      path: "/:videoChooseId",
      element: <VideoChoose />,
    },
    {
      path: "/v2/:videoChooseId",
      element: <VideoChooseV2 />,
    },
    {
      path: "/v3/:videoChooseId",
      element: <VideoChooseV3 />,
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
